/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Lock_ConfirmInputs */

const en_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, lock it`)
};

const fr_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, verrouiller`)
};

const de_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, schließ es ab.`)
};

const it_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, bloccalo`)
};

const ru_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, заблокируйте его.`)
};

const es_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, ciérralo`)
};

const zh_cn2_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对，锁上。`)
};

const ja_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、ロックしてください`)
};

const hi_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हां, इसे लॉक कर दो।`)
};

const pt_pt2_explorer_info_lock_confirm = /** @type {(inputs: Explorer_Info_Lock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, tranque-o.`)
};

/**
* | output |
* | --- |
* | "Yes, lock it" |
*
* @param {Explorer_Info_Lock_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_lock_confirm = /** @type {((inputs?: Explorer_Info_Lock_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Lock_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_lock_confirm(inputs)
	if (locale === "de") return de_explorer_info_lock_confirm(inputs)
	if (locale === "it") return it_explorer_info_lock_confirm(inputs)
	if (locale === "ru") return ru_explorer_info_lock_confirm(inputs)
	if (locale === "es") return es_explorer_info_lock_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_lock_confirm(inputs)
	if (locale === "ja") return ja_explorer_info_lock_confirm(inputs)
	if (locale === "hi") return hi_explorer_info_lock_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_lock_confirm(inputs)
	return en_explorer_info_lock_confirm(inputs)
});